import { render } from "./MentionsLegales.vue?vue&type=template&id=146ac8e0&scoped=true"
import script from "./MentionsLegales.vue?vue&type=script&lang=js"
export * from "./MentionsLegales.vue?vue&type=script&lang=js"

import "./MentionsLegales.vue?vue&type=style&index=0&id=146ac8e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-146ac8e0"]])

export default __exports__